import { render, staticRenderFns } from "./CaseListItem.vue?vue&type=template&id=37ccbf0a&scoped=true&"
import script from "./CaseListItem.vue?vue&type=script&lang=js&"
export * from "./CaseListItem.vue?vue&type=script&lang=js&"
import style0 from "./CaseListItem.vue?vue&type=style&index=0&id=37ccbf0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ccbf0a",
  null
  
)

export default component.exports